import { TaskTimeLogModel } from "@jugl-web/rest-api/tasks/models/TaskTimeLog/TaskTimeLogModel";
import { useCallback, useMemo } from "react";
import { UseTaskTimeLogListOptions } from "./types";

const timeLogListCache = new Map<string, TaskTimeLogModel[]>();

export const useTaskTimeLogListCache = ({
  entityId,
  taskId,
  assigneeIds = [],
}: UseTaskTimeLogListOptions) => {
  const cacheKey = useMemo(
    () => [entityId, taskId, [...assigneeIds].sort().flat()].join("-"),
    [entityId, taskId, assigneeIds]
  );

  const getCachedTimeLogs = useCallback(
    () => timeLogListCache.get(cacheKey),
    [cacheKey]
  );

  const setCachedTimeLogs = useCallback(
    (timeLogs: TaskTimeLogModel[]) => {
      timeLogListCache.set(cacheKey, timeLogs);
    },
    [cacheKey]
  );

  return { getCachedTimeLogs, setCachedTimeLogs };
};
